import {
  gql,
  type QueryHookOptions,
  type TypedDocumentNode,
  useQuery,
} from '@apollo/client'
import type { NullableMetafield } from '@velasca/types'

interface CategoryTileData {
  collection: {
    id: string
    title: string
    handle: string
    squaredBannerImage: NullableMetafield
  } | null
}

interface CategoryTileVariables {
  handle?: string
  id?: string
}

const GET_CATEGORY_TILE: TypedDocumentNode<
  CategoryTileData,
  CategoryTileVariables
> = gql`
  query CategoryTile($handle: String, $id: ID) {
    collection(handle: $handle, id: $id) {
      id
      title
      handle
      squaredBannerImage: metafield(
        namespace: "custom"
        key: "squared_banner_image"
      ) {
        reference {
          ... on MediaImage {
            image {
              url(transform: { maxWidth: 400 })
            }
          }
        }
      }
    }
  }
`

export default function useCategoryTile(
  options: QueryHookOptions<CategoryTileData, CategoryTileVariables>,
) {
  const { loading, data, error, refetch } = useQuery(GET_CATEGORY_TILE, options)

  return { loading, data, error, refetch }
}
